import { registerPlugin } from '@capacitor/core';

export interface BackgroundLocationPermissionsResult {
  success: boolean;
  status: string;
}

export interface BackgroundLocationPermissionsPlugin {
  requestNotificationPermission(): Promise<BackgroundLocationPermissionsResult>;
  requestBackgroundLocationPermission(): Promise<BackgroundLocationPermissionsResult>;
  openAppSettings(): Promise<BackgroundLocationPermissionsResult>;
  openBatteryOptimizationSettings(): Promise<BackgroundLocationPermissionsResult>;
  isIgnoringBatteryOptimizations(): Promise<BackgroundLocationPermissionsResult & { status: boolean }>;
  sentrySmokeTest(): Promise<{ ok: boolean }>;
}

const BackgroundLocationPermissions = registerPlugin<BackgroundLocationPermissionsPlugin>(
  'BackgroundLocationPermissions',
  {
    web: () =>
      Promise.resolve({
        requestNotificationPermission: () => Promise.resolve({ success: true, status: 'not_required' }),
        requestBackgroundLocationPermission: () => Promise.resolve({ success: true, status: 'not_required' }),
        openAppSettings: () => Promise.resolve({ success: false, status: 'not_supported' }),
        openBatteryOptimizationSettings: () => Promise.resolve({ success: false, status: 'not_supported' }),
        isIgnoringBatteryOptimizations: () => Promise.resolve({ success: true, status: true }),
      } as unknown as BackgroundLocationPermissionsPlugin),
  }
);

export { BackgroundLocationPermissions };
